function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M217.478 0H78.1183C68.8155 0 61.274 7.53898 61.274 16.8388V309.919C61.274 319.219 68.8155 326.758 78.1183 326.758H217.478C226.781 326.758 234.322 319.219 234.322 309.919V16.8388C234.322 7.53898 226.781 0 217.478 0Z",
  fill: "#EDEEEF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M226.63 35.8789H68.9662V290.879H226.63V35.8789Z",
  fill: "white",
  stroke: "#1A2E35",
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M164.938 18.0304H130.659C130.038 18.0304 129.443 17.7839 129.004 17.3451C128.565 16.9062 128.318 16.3111 128.318 15.6905C128.318 15.0699 128.565 14.4747 129.004 14.0359C129.443 13.5971 130.038 13.3506 130.659 13.3506H164.938C165.559 13.3506 166.154 13.5971 166.593 14.0359C167.032 14.4747 167.279 15.0699 167.279 15.6905C167.279 16.3111 167.032 16.9062 166.593 17.3451C166.154 17.7839 165.559 18.0304 164.938 18.0304V18.0304Z",
  fill: "#AAAAAA"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M147.801 318.574C152.964 318.574 157.15 314.389 157.15 309.227C157.15 304.065 152.964 299.88 147.801 299.88C142.637 299.88 138.451 304.065 138.451 309.227C138.451 314.389 142.637 318.574 147.801 318.574Z",
  fill: "#AAAAAA"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M152.537 304.488H143.06V313.962H152.537V304.488Z",
  fill: "#AAAAAA",
  stroke: "black",
  strokeMiterlimit: 10
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M137.933 70.7411V92.739L125.219 79.82H9.08187C6.67321 79.82 4.3632 78.8635 2.66002 77.1609C0.956837 75.4582 0 73.149 0 70.7411L0 53.7689C0 51.361 0.956837 49.0517 2.66002 47.3491C4.3632 45.6465 6.67321 44.69 9.08187 44.69H128.851C131.26 44.69 133.57 45.6465 135.273 47.3491C136.976 49.0517 137.933 51.361 137.933 53.7689V70.7411Z",
  fill: "#E3D7FF"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M105.915 50.2234H7.29688C6.66249 50.2234 6.14821 50.7375 6.14821 51.3717C6.14821 52.0059 6.66249 52.52 7.29688 52.52H105.915C106.55 52.52 107.064 52.0059 107.064 51.3717C107.064 50.7375 106.55 50.2234 105.915 50.2234Z",
  fill: "#AD7FE0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M56.4929 59.9419H6.72471C6.40655 59.9419 6.14388 59.4289 6.14388 58.7936C6.14388 58.1584 6.40395 57.6454 6.72471 57.6454H56.4929C56.8111 57.6454 57.0738 58.1584 57.0738 58.7936C57.0694 59.4297 56.8111 59.9419 56.4929 59.9419Z",
  fill: "#AD7FE0"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M94.745 67.0597H7.16511C6.87921 67.0409 6.61219 66.9104 6.42187 66.6963C6.23155 66.4822 6.13324 66.2017 6.14821 65.9157C6.13206 65.6289 6.22984 65.3474 6.42028 65.1324C6.61072 64.9173 6.87841 64.7861 7.16511 64.7674H94.745C95.0317 64.7861 95.2994 64.9173 95.4898 65.1324C95.6803 65.3474 95.778 65.6289 95.7619 65.9157C95.7769 66.2017 95.6785 66.4822 95.4882 66.6963C95.2979 66.9104 95.0309 67.0409 94.745 67.0597V67.0597Z",
  fill: "#AD7FE0"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M130.75 59.9419H64.4799C64.0534 59.9419 63.7083 59.4289 63.7083 58.7936C63.7083 58.1584 64.0551 57.6454 64.4799 57.6454H130.731C131.157 57.6454 131.502 58.1584 131.502 58.7936C131.522 59.4297 131.176 59.9419 130.75 59.9419Z",
  fill: "#AD7FE0"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M130.369 50.2234H114.094C113.459 50.2234 112.945 50.7375 112.945 51.3717C112.945 52.0059 113.459 52.52 114.094 52.52H130.369C131.003 52.52 131.517 52.0059 131.517 51.3717C131.517 50.7375 131.003 50.2234 130.369 50.2234Z",
  fill: "#AD7FE0"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M79.1378 74.1774H6.98826C6.53399 74.1774 6.14821 73.6643 6.14821 73.029C6.14821 72.3938 6.52532 71.8807 6.98826 71.8807H79.1378C79.5921 71.8807 79.9778 72.3938 79.9778 73.029C79.9752 73.6652 79.6016 74.1774 79.1378 74.1774Z",
  fill: "#AD7FE0"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M288 89.3019V106.271C288 108.679 287.043 110.988 285.34 112.69C283.637 114.393 281.327 115.35 278.918 115.35H162.799L150.085 128.274V89.3019C150.084 88.109 150.319 86.9278 150.776 85.8257C151.232 84.7235 151.901 83.7221 152.745 82.8786C153.589 82.0352 154.59 81.3662 155.693 80.9099C156.795 80.4537 157.977 80.219 159.17 80.2195H278.918C280.111 80.2195 281.292 80.4544 282.394 80.9109C283.497 81.3674 284.498 82.0364 285.341 82.8799C286.185 83.7233 286.854 84.7245 287.31 85.8265C287.766 86.9284 288 88.1093 288 89.3019V89.3019Z",
  fill: "#F3FFAB"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M280.707 85.753H182.088C181.454 85.753 180.94 86.2671 180.94 86.9013C180.94 87.5355 181.454 88.0496 182.088 88.0496H280.707C281.341 88.0496 281.855 87.5355 281.855 86.9013C281.855 86.2671 281.341 85.753 280.707 85.753Z",
  fill: "#C6E547"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M231.511 95.4767H281.272C281.59 95.4767 281.853 94.9637 281.853 94.3284C281.853 93.6932 281.593 93.1801 281.272 93.1801H231.511C231.192 93.1801 230.93 93.6932 230.93 94.3284C230.93 94.9593 231.189 95.4767 231.511 95.4767Z",
  fill: "#C6E547"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M157.713 102.589H245.293C245.58 102.57 245.847 102.439 246.038 102.224C246.228 102.009 246.326 101.728 246.31 101.441V101.441C246.326 101.154 246.228 100.873 246.038 100.658C245.847 100.443 245.58 100.311 245.293 100.293H157.713C157.426 100.311 157.159 100.443 156.968 100.658C156.778 100.873 156.68 101.154 156.696 101.441V101.441C156.68 101.728 156.778 102.009 156.968 102.224C157.159 102.439 157.426 102.57 157.713 102.589V102.589Z",
  fill: "#C6E547"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M157.254 95.4767H223.505C223.932 95.4767 224.277 94.9637 224.277 94.3284C224.277 93.6932 223.93 93.1801 223.505 93.1801H157.254C156.828 93.1801 156.483 93.6932 156.483 94.3284C156.483 94.9593 156.828 95.4767 157.254 95.4767Z",
  fill: "#C6E547"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M173.906 85.753H157.631C156.997 85.753 156.483 86.2671 156.483 86.9013C156.483 87.5355 156.997 88.0496 157.631 88.0496H173.906C174.541 88.0496 175.055 87.5355 175.055 86.9013C175.055 86.2671 174.541 85.753 173.906 85.753Z",
  fill: "#C6E547"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M157.522 109.712H229.676C230.13 109.712 230.516 109.199 230.516 108.564C230.516 107.929 230.139 107.416 229.676 107.416H157.522C157.068 107.416 156.682 107.929 156.682 108.564C156.682 109.195 157.059 109.712 157.522 109.712Z",
  fill: "#C6E547"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M35.777 334.584C43.4926 284.624 88.823 262.953 88.823 262.953L107.695 272.699C108.358 272.699 104.158 290.598 104.158 290.598L76.1998 302.977L50.317 343L30.6231 336.192L35.777 334.584Z",
  fill: "#CA256A"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M74.6289 272.022C79.8753 269.472 85.7372 268.459 91.5355 269.102C97.3339 269.744 102.832 272.016 107.392 275.654C106.483 280.742 104.159 290.579 104.159 290.579L76.2007 302.958L65.0252 320.253C60.5369 315.19 57.8365 308.793 57.3394 302.047C56.8422 295.3 58.5758 288.577 62.2736 282.912C66.1215 278.986 70.2509 275.346 74.6289 272.021V272.022Z",
  fill: "black"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M60.1435 292.068C61.0521 266.52 91.5261 262.429 91.5261 262.429L126.803 253.751C126.803 253.751 132.62 292.272 88.1234 292.917L109.166 334.57L89.8269 342.986L91.5296 337.149C91.5296 337.149 59.6035 307.315 60.1435 292.068Z",
  fill: "#FF6498"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M126.804 253.751C126.804 253.751 132.621 292.272 88.1243 292.917L109.167 334.57",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M183.96 183.899L184.845 223.11L148.109 226.288L145.989 250.274L151.084 245.181C151.084 245.181 206.083 256.643 218.824 245.181C231.565 233.719 201.092 191.063 201.092 191.063",
  fill: "#D5775E"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M184.36 201.59L184.845 223.111L161.945 225.095C161.066 229.436 160.628 233.856 160.637 238.286C160.636 241.206 160.824 244.124 161.201 247.02C171.299 248.666 187.138 250.746 200.039 250.198C200.747 246.27 201.1 242.286 201.092 238.295C201.092 219.91 193.868 204.64 184.36 201.59Z",
  fill: "black"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M195.425 183.899C195.425 183.899 199.712 253.842 187.605 286.943L190.135 290.656H168.597C168.597 290.656 166.245 201.684 166.245 182.487L195.425 183.899Z",
  fill: "#FA7F58"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M195.425 183.899C195.425 183.899 199.712 253.842 187.605 286.943L190.135 290.656",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M188.273 130.18V139.268L177.012 142.041V126.702L188.273 123.929V130.18Z",
  fill: "#F8D6CC"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M181.911 133.322C182.077 133.322 182.211 133.188 182.211 133.022C182.211 132.857 182.077 132.722 181.911 132.722C181.746 132.722 181.611 132.857 181.611 133.022C181.611 133.188 181.746 133.322 181.911 133.322Z",
  fill: "black"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M186.539 133.322C186.705 133.322 186.839 133.188 186.839 133.022C186.839 132.857 186.705 132.722 186.539 132.722C186.373 132.722 186.239 132.857 186.239 133.022C186.239 133.188 186.373 133.322 186.539 133.322Z",
  fill: "black"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M185.18 134.819V130.18H187.506",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M181.344 130.18H183.669",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M177.752 132.55V134.161C177.337 134.158 176.94 133.993 176.647 133.699C176.354 133.406 176.188 133.009 176.185 132.595V132.449C176.213 132.253 176.314 132.074 176.468 131.949C176.622 131.824 176.817 131.761 177.015 131.774C177.213 131.787 177.399 131.874 177.536 132.018C177.672 132.161 177.749 132.352 177.752 132.55Z",
  fill: "#F8D6CC"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M177.752 134.166C177.336 134.164 176.939 133.997 176.645 133.703C176.352 133.409 176.187 133.011 176.185 132.596",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M184.165 137.149C183.743 137.149 183.337 136.981 183.038 136.682C182.739 136.383 182.571 135.978 182.571 135.555",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M188.273 139.268L177.012 142.037",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M185.181 134.824L184.164 135.072",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M177.752 129.4C178.356 129.027 178.86 128.513 179.22 127.903C179.581 127.292 179.788 126.603 179.823 125.895L183.669 127.053V125.541L187.505 127.049V125.541L189.094 126.176",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M188.273 130.18C188.273 130.18 190.861 128.759 190.225 124.733C188.377 123.817 186.342 123.341 184.279 123.341C182.216 123.341 180.181 123.817 178.333 124.733L178.901 122.463C178.901 122.463 175.981 123.666 176.494 125.364L174.582 125.504L176.185 126.648C176.185 126.648 173.833 129.272 176.971 131.782",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M127.144 228.208V253.752L90.9262 262.649V234.187C90.9264 229.283 92.5708 224.521 95.5966 220.662C98.6224 216.803 102.855 214.068 107.618 212.897C109.939 212.325 112.359 212.289 114.696 212.791C117.033 213.293 119.225 214.32 121.106 215.794C122.988 217.268 124.509 219.15 125.555 221.298C126.601 223.447 127.144 225.805 127.144 228.195L127.144 228.208Z",
  fill: "#AD7FE0"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M99.0545 242.975L96.4233 233.406L86.5604 234.619L90.9427 249.4L100.132 248.165",
  fill: "#E3D7FF"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M99.0545 242.975L96.4233 233.406L86.5604 234.619L90.9427 249.4L100.132 248.165",
  stroke: "black",
  strokeMiterlimit: 10
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M124.288 219.252C124.288 219.252 142.524 239.679 138.696 256.538C134.869 273.397 96.0619 258.059 95.1585 250.941C94.2552 243.824 101.175 248.386 101.175 248.386C101.175 248.386 100.721 244.582 102.083 246.053C103.446 247.523 104.409 248.704 104.409 248.704L120.029 246.915L116.119 238.236",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M86.5613 232.448C90.1937 234.268 90.9435 231.308 90.9435 231.308C91.5747 231.531 93.5729 233.755 93.3501 231.308C93.3006 230.626 93.0436 229.975 92.6134 229.443C92.1833 228.911 91.6006 228.522 90.9435 228.331C90.9435 228.331 81.3762 225.925 80.6038 237.554C79.8313 249.184 85.3536 256.62 90.9435 254.586",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M99.4766 216.837C95.3453 219.83 91.916 223.687 89.4273 228.14",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M102.546 196.201V200.404C102.546 201.983 103.076 203.516 104.05 204.759C105.025 206.001 106.388 206.881 107.921 207.258L114.615 208.905V192.469L109.053 191.108C108.28 190.918 107.473 190.906 106.695 191.074C105.917 191.241 105.187 191.583 104.561 192.074C103.934 192.566 103.428 193.193 103.08 193.908C102.731 194.624 102.55 195.409 102.551 196.205L102.546 196.201Z",
  fill: "#FFD5E8"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M102.546 200.404C102.546 201.983 103.076 203.516 104.05 204.759C105.025 206.001 106.388 206.881 107.921 207.258L114.615 208.905",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M109.362 199.57C109.54 199.57 109.685 199.425 109.685 199.247C109.685 199.069 109.54 198.925 109.362 198.925C109.184 198.925 109.04 199.069 109.04 199.247C109.04 199.425 109.184 199.57 109.362 199.57Z",
  fill: "black"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M104.408 199.57C104.586 199.57 104.73 199.425 104.73 199.247C104.73 199.069 104.586 198.925 104.408 198.925C104.23 198.925 104.085 199.069 104.085 199.247C104.085 199.425 104.23 199.57 104.408 199.57Z",
  fill: "black"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M105.861 201.172V196.201H103.373",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M109.97 196.201H107.482",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M113.822 198.747V200.472C114.268 200.472 114.697 200.294 115.013 199.979C115.329 199.663 115.506 199.234 115.506 198.788C115.506 198.736 115.506 198.685 115.506 198.634C115.477 198.421 115.368 198.228 115.202 198.092C115.036 197.957 114.825 197.89 114.611 197.904C114.397 197.919 114.196 198.014 114.05 198.17C113.903 198.327 113.822 198.533 113.822 198.747V198.747Z",
  fill: "#FFD5E8"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M113.822 200.473C114.268 200.473 114.697 200.295 115.013 199.979C115.329 199.664 115.506 199.235 115.506 198.789",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M107.223 203.332C107.327 203.436 107.45 203.517 107.586 203.573C107.722 203.629 107.867 203.658 108.014 203.658C108.16 203.658 108.306 203.629 108.441 203.573C108.577 203.517 108.7 203.436 108.804 203.332",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M105.862 201.176L106.951 201.442",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M102.546 199.247C102.546 199.247 99.1047 196.31 100.552 192.519C101.914 188.966 109.048 186.578 113.062 189.083C113.627 189.441 114.224 189.745 114.846 189.991C117.421 190.995 123.928 194.921 123.565 208.925C123.111 226.351 112.454 217.636 113.444 213.691C114.434 209.746 115.115 206.452 114.62 203.042",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M114.044 218.19C114.529 218.885 115.168 219.459 115.912 219.867C116.655 220.275 117.483 220.505 118.33 220.541",
  stroke: "#FF6498",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M113.785 218.939C111.742 219.478 109.923 220.655 108.595 222.298C107.267 223.942 106.499 225.966 106.402 228.077C106.297 229.863 105.818 231.608 104.994 233.197C103.841 235.43 102.646 238.848 103.867 241.972C105.906 247.178 118.275 232.121 116.885 221.34",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M166.432 158.357V183.056L201.433 191.654V164.144C201.433 159.405 199.843 154.803 196.918 151.074C193.994 147.344 189.903 144.703 185.299 143.572C183.057 143.021 180.719 142.988 178.461 143.473C176.204 143.959 174.087 144.952 172.27 146.376C170.452 147.8 168.983 149.619 167.973 151.695C166.962 153.77 166.437 156.048 166.437 158.357H166.432Z",
  fill: "#C6E547"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M193.591 172.628L196.133 163.377L205.664 164.553L201.432 178.839L192.55 177.644",
  fill: "#E3D7FF"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M193.591 172.628L196.133 163.377L205.664 164.553L201.432 178.839L192.55 177.644",
  stroke: "black",
  strokeMiterlimit: 10
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M169.202 149.69C169.202 149.69 151.579 169.432 155.293 185.724C159.007 202.016 196.493 187.197 197.364 180.318C198.235 173.439 191.556 177.849 191.556 177.849C191.556 177.849 191.978 174.172 190.698 175.579C189.417 176.987 188.427 178.144 188.427 178.144L173.333 176.41L177.111 168.027",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M205.665 162.451C202.146 164.19 201.433 161.353 201.433 161.353C200.826 161.566 198.89 163.718 199.108 161.353C199.155 160.693 199.403 160.064 199.819 159.549C200.235 159.035 200.798 158.66 201.433 158.474C201.433 158.474 210.678 156.15 211.422 167.385C212.167 178.62 206.828 185.797 201.433 183.845",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M193.177 147.367C197.168 150.259 200.482 153.985 202.887 158.286",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M103.745 191.521C103.745 191.521 110.941 194.213 115.506 193.627L114.597 196.061",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M184.872 146.613L189.667 171.572L187.9 176.189L183.459 172.389L183.759 146.791L182.198 144.549H185.931L184.872 146.613Z",
  fill: "black"
});

var SvgMobile = function SvgMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 343,
    viewBox: "0 0 288 343",
    fill: "none",
    className: "mt-16 sm:hidden",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Mobile.cadfd893.svg";
export { ForwardRef as ReactComponent };